(function () {
    'use strict';

    angular
        .module('directives.govBreadcrumb', [])
        .directive('govBreadcrumb', directive);

    /**
     * @property {GovBreadcrumb} $state.data.breadcrumb
     *
     * @typedef {object} GovBreadcrumb
     * @property {string}   [titlePath] - Path to get the title value, e.g. from a resolved object's property (ex: 'control.TitleEN')
     * @property {string}   [title] - String to use as the title for the breadcrumb, also used as default if titlePath is not found
     * @property {string}   [cssIcon] - String to use as the css classes in a <i> element to display an icon in front of the title
     * @property {boolean}  [showWhenActive=false] - True to display the breadcrumb info even when the state is the active one
     * @property {boolean}  [usingHistoryCtxt=false] - True to use the historyCtxtService to determine the click action's URL
     * @property {string}   [defaultCtxtState] - Defines a default context when using usingHistoryCtxt but no context is found (i.e. after reload)
     * @property {object}   [defaultCtxtStateParams] - Defines parameters for the default context state to navigate to if usingHistoryCtxt
     * @property {boolean}  [stateReload=false] - True to force a state reload when navigating using that breadcrumb element
     * @property {function} [getBreadcrumb] - Defines a function to execute to return the GovBreadcrumb.
     *                                      It is called with the resolved values as the first param.
     *
     */

    directive.$inject = [];

    function directive() {
        /**
         * Warning: if you add an isolated scope to pass parameters, the authenticatedUser would not
         * get inherited from rootScope, so it would need to be injected using the authenticatedUserService
         */
        return {
            restrict: 'A',
            templateUrl: require('./govBreadcrumb.tpl.html'),
            controller: ['$rootScope', '$scope', '$state', 'historyCtxtService', function ($rootScope, $scope, $state, historyCtxtService) {

                $scope.ctrlCtxt = {
                    breadcrumbElements: [],
                    contextState: null
                };

                init();

                // Destroy previous event listener as a new scope has been created
                if ($rootScope.unregisterBreadcrumbStateChange) {
                    $rootScope.unregisterBreadcrumbStateChange();
                    $rootScope.unregisterBreadcrumbStateChange = null;
                }

                $rootScope.unregisterBreadcrumbStateChange =
                    $rootScope.$on('$stateChangeSuccess', function () {

                        // New view is not part of this breadcrumbs context, remove event
                        if (!$state.includes($scope.ctrlCtxt.contextState)) {
                            $rootScope.unregisterBreadcrumbStateChange();
                            $rootScope.unregisterBreadcrumbStateChange = null;

                            return;
                        }

                        init();
                    });

                // Parent view of the breadcrumbs, used to detect when to clean up the breadcrumbs
                $scope.ctrlCtxt.contextState = $state.current.name.substr(0, $state.current.name.indexOf('.'));

                function init() {
                    $scope.ctrlCtxt.breadcrumbElements = [];
                    $scope.showActiveState = _.get($state, 'current.data.breadcrumb.showWhenActive', false);

                    // Initialize breadcrumb using recursion
                    setBreadcrumbElement($state.current, $state);
                }

                function setBreadcrumbElement(state, initialState) {
                    var breadcrumbEl;

                    // Skip if view does not have breadcrumb info
                    if (state.data && state.data.breadcrumb) {
                        var breadcrumbs = state.data.breadcrumb;
                        if (!_.isArray(breadcrumbs)) breadcrumbs = [breadcrumbs];

                        _.eachRight(breadcrumbs, function (breadcrumb) {
                            if (_.isFunction(breadcrumb.getBreadcrumb)) {
                                breadcrumb = breadcrumb.getBreadcrumb($state.$current.locals.resolve.$$values);
                            }
                            breadcrumbEl = _.cloneDeep(breadcrumb);

                            if (!breadcrumbEl.stateName) breadcrumbEl.stateName = state.name;

                            $scope.ctrlCtxt.breadcrumbElements.unshift(breadcrumbEl);
                        });

                    }

                    // Find parent state using dot notation and recurse
                    var parentDotIdx = state.name.lastIndexOf('.');
                    if (parentDotIdx > 0) {
                        setBreadcrumbElement($state.get(state.name.substr(0, parentDotIdx)), initialState);
                    }
                }

                // Get Breadcrumb Title
                $scope.getBreadcrumbElTitle = function (breadcrumbEl) {
                    // Using history context param
                    if (breadcrumbEl.usingHistoryCtxt
                        && historyCtxtService.hasContext()
                        && $state.params.ctxtBreadcrumbTitle) {

                        return $state.params.ctxtBreadcrumbTitle;
                    }

                    // Get from resolve using titlePath, default to title property
                    return _.get($state.$current.locals.resolve.$$values, breadcrumbEl.titlePath, breadcrumbEl.title);
                };

                // Get Breadcrumb Icon
                $scope.getBreadcrumbElIcon = function (breadcrumbEl) {
                    // Using history context param
                    if (breadcrumbEl.usingHistoryCtxt
                        && historyCtxtService.hasContext()
                        && !_.isUndefined($state.params.ctxtBreadcrumbIcon)) {

                        return $state.params.ctxtBreadcrumbIcon;
                    }

                    return breadcrumbEl.cssIcon;
                };

                // Is Current State
                $scope.isCurrentState = function (breadcrumbEl) {
                    return $state.is(breadcrumbEl.stateName);
                };

                // Show Breadcrumb Element
                $scope.showBreadcrumbElem = function (breadcrumbEl, isLast) {

                    if (isLast && $scope.isCurrentState(breadcrumbEl)) {
                        return $scope.showActiveState;
                    }

                    return true;
                };

                // Navigate to the clicked breadcrumb element
                $scope.goToState = function (breadcrumbEl) {
                    if (!breadcrumbEl.usingHistoryCtxt) {
                        $state.go(breadcrumbEl.stateName, breadcrumbEl.stateParams, {
                            reload: !!breadcrumbEl.stateReload
                        });
                        return;
                    }

                    // Using context
                    if (historyCtxtService.hasContext()) {
                        historyCtxtService.goToContext();

                        return;
                    }

                    // No default context
                    if (!breadcrumbEl.defaultCtxtState) {
                        console.warn(
                            'No default state defined for context breadcrumb navigation ' +
                            'while no context was available. View: ' +
                            breadcrumbEl.stateName);

                        return;
                    }

                    // Navigate to default context defined in data.breadcrumb
                    $state.go(breadcrumbEl.defaultCtxtState, breadcrumbEl.defaultCtxtStateParams);
                };
            }]
        };
    }
})();